import { Trascodifica } from '.';

export class Servizio {
	id: number;
	tipologiaServizio: Trascodifica;
	sottoTipologiaServizio: Trascodifica;
	sottoCategorie: Array<Servizio>;
	costo: number;
	costoScontato: number;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/servizio.ts